import { useEffect } from "react";
import ProductForm from "./forms/ProductForm"
import { Form } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { selectIsOwner } from "../../../app/store/reducers/auth/authReducer";
import { getCategoriesAsync, getCategoryCountAsync, selectCategoryFilterOptions } from "../../../app/store/reducers/category/categoryReducer";
import { getCurrenciesAsync, getCurrenciesCountAsync, selectCurrencyFilterOptions } from "../../../app/store/reducers/currency/currencyReducer";
import { PATH_IMAGE } from "../../../helper/path";
import { productUpdateAsync } from "../../../app/store/reducers/product/productReducer";
import { useNavigate } from "react-router-dom"




const UpdateProduct = ({product}) => {
    const isOwner = useSelector(selectIsOwner)
    const filterCategories = useSelector(selectCategoryFilterOptions)
    const filterCurrencies = useSelector(selectCurrencyFilterOptions)
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [form] = Form.useForm()
  const initialValues = {
      name: product?.name,
      currency_id: product?.price?.currency?.id,
      amount: product?.price?.amount,
      category_id: product?.category?.category_id,
      image: {
        uid: '-1',
        name: product?.image?.filename,
        status: "done",
        url: PATH_IMAGE+product?.image?.path,
      },
      description: product?.description,
      residual: product?.residual,
  }

  console.log("product", product);
  

  const onSubmit = async (values) => {
      // console.log("values", values)
      // console.log("test version", form.getFieldValue('image'))
      const image = form.getFieldValue("image")
      const productUpdate = {
        category_id: values?.category_id,
        name: values?.name,
        description: values?.description,
        price: {
            amount: values?.amount,
            currency_id: values?.currency_id
        },
        residual: values?.residual,
        image: image?.url ? product?.image
          : 
          {
            filename: image?.filename,
            base64: image?.base64,
            size: image?.size
          }
    }

    await productUpdateAsync({id: product?.id, product: productUpdate})
        .then((response) => {
            // console.log(response);
            navigate("../my")
        })
        .catch((error) => {

        })
  }

  useEffect(() => {
    if (isOwner) {
      dispatch(getCurrenciesAsync({...filterCategories}))
      dispatch(getCurrenciesCountAsync({...filterCategories}))
      dispatch(getCategoriesAsync({...filterCurrencies}))
      dispatch(getCategoryCountAsync({...filterCurrencies}))
    }
  },[isOwner])


return (
  <>
      <Form
          form={form}
          initialValues={initialValues}
          layout="vertical"
          onFinish={onSubmit}
      >
          <ProductForm/>
      </Form>
  </>
)
}

export default UpdateProduct